import { RouteConfig } from 'vue-router'

export const CpdRoutes: RouteConfig[] = [
  {
    path: '/cpd/summary',
    name: 'cpd-summary',
    component: () => import('@core/pages/cpd/summary/CpdSummary.vue')
  },
  {
    path: '/cpd/course/:courseId',
    name: 'cpd-course',
    component: () => import('@core/pages/cpd/course/CpdCourse.vue')
  }
]
